import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useBenefits } from '../BenefitsContext';
import useNavigationPaths from '../../../../customHooks/useNavigationPaths.hook';
import { useIsTenantProtectionAvailable } from '../../../../customHooks/useIsTenantProtectionAvailable';
import { MIETERSCHUTZ, MIETRECHTSBERATUNG, SCHLUSSELDIENST } from '../../../../domain/routes';
import { useModalSelectionByQuery, useModalSelection } from '../../../../customHooks/useModalSelection.hook';
import { useValidateOperationToken } from '@/customHooks/useValidateOperationToken.hook';
import { SecuredOperation } from '@/@types/validateToken';
import { useIsKeyAndLegalAvailable } from '@/customHooks/useIsKeyAndLegalAvailable.hook';

/*
 * This is a React component that is responsible
 * for managing and displaying different modal windows
 * based on the current navigation path within the application.
 */
export const BenefitsModals = () => {
  const { parentPath, nestedPath, clearNestedPath } = useNavigationPaths();
  const { onCloseModal } = useBenefits();
  const ModalComponent = useModalSelection(parentPath, nestedPath);
  useModalSelectionByQuery();
  const { validateOperationToken } = useValidateOperationToken();

  const [searchParams] = useSearchParams();
  const isTenantProtectionEntitled = useIsTenantProtectionAvailable();
  const isKeyAndLegalEntitled = useIsKeyAndLegalAvailable();

  useEffect(() => {
    if (nestedPath === MIETERSCHUTZ) {
      const token = searchParams.get('token');
      if (!isTenantProtectionEntitled && !token) {
        clearNestedPath();
        return;
      }
      if (token) validateOperationToken(token, SecuredOperation.LEGACY_TENANT_PROTECTION);
    } else if (nestedPath === SCHLUSSELDIENST || nestedPath === MIETRECHTSBERATUNG) {
      const token = searchParams.get('token');
      if (!isKeyAndLegalEntitled && !token) {
        clearNestedPath();
        return;
      }
      if (token) validateOperationToken(token, SecuredOperation.LEGACY_KEY_AND_LEGAL);
    }
  }, [nestedPath]);

  if (!ModalComponent) {
    return null;
  }

  return <ModalComponent isVisible={!!ModalComponent} onClose={onCloseModal} />;
};
